import { RoleContactModel } from "./role-contact.model";

export class RoleContactsModel {
    roleId: number;
    companyId: number;
    roleContacts: RoleContactModel[];
    username: string

    /**
     * 
     * @param companyId 
     * @param roleId 
     * @param roleContacts 
     */
     constructor(companyId: number, roleId: number, roleContacts: RoleContactModel[], username: string) {
        this.companyId = companyId;
        this.roleId = roleId;
        this.roleContacts = roleContacts;
        this.username = username;
    }

}